import { Users } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

const teamSection = {
  type: SECTION_TYPES.TEAM,
  content: {
    header: "Our Awesome Team",
    subheader: "We are a team of professionals.",
    members: [
      {
        name: "John Doe",
        title: "Owner",
        bio: "John has been in the industry for 20 years and enjoys spending his free time outside.",
        image: "https://utfs.io/f/2a78093d-cc44-44a5-b606-f22dc959535d-fxhp46.png",
      },
      {
        name: "Jack Doe",
        title: "Employee",
        bio: "Jack has been in the industry for 20 years and enjoys spending his free time outside.",
        image: "https://utfs.io/f/cdef0021-26dd-4f1b-8486-ebcc53c73ab5-6q02qs.png",
      },
    ],
  },
  meta: {
    displayName: "Our Team",
    displayDescription: "Tell your customers about your team to help inspire trust.",
    displayIcon: Users,
    variantsCount: 5,
  },
};

export default teamSection;
